import type {
  Placement,
  AppendTo,
} from '../internal/WixUiCoreComponents/components/CorePopover';
import type { TPAComponentProps } from '../../types';
import type { DropdownOptionProps } from '../Dropdown';

export interface FloatingDropdownProps extends TPAComponentProps {
  /** Defines a string value that labels the current element. Optional. */
  'aria-label'?: string;
  /** Identifies the element (or elements) that labels the current element. Optional. */
  'aria-labelledby'?: string;
  /** Applies disabled styles. Optional. Boolean. */
  disabled?: boolean;
  /** Label string value. Required. */
  label: string;
  /** Callback which is being called when value changes. Function. Optional. */
  onChange?(selectedOption: FloatingDropdownOptionProps): void;
  /** An array of dropdown option items. Option item structure: { id: string; value: string; isSelectable: boolean; } */
  options: FloatingDropdownOptionProps[];
  /** A placeholder which is being displayed when no value is selected. String. Optional. */
  placeholder?: string;
  /** An id of initially selected item. String. Optional. */
  value?: string;
  /** Force dropdown open. Use for visual test. Optional. Boolean. */
  forceContentElementVisibility?: boolean;
  /** Placement for Popover. Default value is `bottom`, when `removeElementMinWidth=true` default value is `bottom-start`. Optional. Placement. */
  placement?: Placement;
  /** Element to append the Popover to */
  appendTo?: AppendTo;
  /** A Callback triggered when the dropdown has been opened or closed  */
  onExpandedChange?(isExpanded: boolean): void;
  name?: string;
  id?: string;
  /** Sets the display type of the component to be block if true */
  displayBlock?: boolean;
  /**
   * popovers content is set to minnimum width of trigger element,
   * but it can expand up to the value of maxWidth.
   */
  dynamicWidth?: boolean;
  /** Removes min-width from dropdown and adds it to popover */
  removeElementMinWidth?: boolean;
  optionsContainerId?: string;
}

export type FloatingDropdownDefaultProps = Required<
  Pick<FloatingDropdownProps, 'disabled' | 'options' | 'displayBlock'>
>;

export interface FloatingDropdownOptionProps extends DropdownOptionProps {}

export interface FloatingDropdownBaseProps extends TPAComponentProps {
  'aria-label'?: string;
  'aria-labelledby'?: string;
  'aria-activedescendant'?: string;
  'aria-controls'?: string;
  disabled: boolean;
  label: string;
  placeholder: string;
  value: string;
  mobile?: boolean;
  options: FloatingDropdownOptionProps[];
  name?: string;
  id?: string;
  onChange?(id: string): void;
  isExpanded: boolean;
  displayBlock?: boolean;
}
